export type DisabledDate = Date | [Date, Date];

export type CalendarFormValue = null | Date | [Date | null, Date | null];
